import ReactPaginate from "react-paginate";
import React from "react";
import { Container } from "./styled";

export const Pagination = (props) => (
  <Container>
    <ReactPaginate {...props} />
  </Container>
);
